'use strict';

import BaseService from './base.service';

class ProceduresService extends BaseService {
    /* @ngInject */
    constructor(Procedure, Item, SegaUser) {
        super(Procedure, SegaUser);
        Object.assign(this, {Item});
    }

    findByPlate(opts = {plate: ''}) {
        let clientId = opts.clientId || opts.client.id;
        return this.find({
            filter: {
                where: {
                    plate: {
                        ilike: `%${opts.plate}%`
                    },
                    clientId: clientId
                },
                order: 'plate ASC'
            }
        });
    }

    destroyById(id) {
        return this.Model.items.destroyAll({
            id: id
        }).$promise.then(() => {
            return super.destroyById(id);
        });
    }
}

export default ProceduresService;
